import { NavigationGuard } from 'vue-router'
import useUser from '@/composables/useUser'
import { useModalStore, Modal } from '@/store/pinia/modalStore'
import { inject } from 'vue'
import { FeatureFlags } from '@/types'

export const userCanAccessResumeScan: NavigationGuard = (
  _to,
  _from,
  next
) => {
  const featureFlags = inject<FeatureFlags>('featureFlags')
  if (!featureFlags?.resumeScan) {
    // Resume Scan feature flag is off.
    return next(false)
  }

  if (useUser().allowResumeScan.value) {
    return next()
  }

  // User lacks permission to access Resume Scan.
  useModalStore().openModal(Modal.ResumeScanUpgradeModal)
  next(false)
}
